export default __webpack_public_path__ + "static/media/tal_rapke.303e32a8.jpg";